module.exports = __webpack_public_path__ + "img/diamonds-2@2x.ebe3064.webp";